import normalizeOrganizationRole from './normalizeOrganizationRole';

export default normalizeOrganizationRole;
